import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
//import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { StorageProvider } from 'providers/storage'



export const AVAILABLE_LANGUAGES = ['en', 'es']

i18n
  // Load translation using xhr -> see /public/locales
  // Docs: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // Detect user language
  // Docs: https://github.com/i18next/i18next-browser-languageDetector
  //.use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // Init i18next
  // Docs: https://www.i18next.com/overview/configuration-options
  .init({
    lng: StorageProvider.get('language'),
    detection: {
      checkForSimilarInWhitelist: true,
    },
    whitelist: AVAILABLE_LANGUAGES,
    fallbackLng: ['es'],
    debug: true,
    saveMissing: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  })

export default i18n
